export const renderAddressSplit = (address: string) => {
  if (address === undefined || address === null || address === '')
    return 'N/A';
  if (address.length < 10)
    return address;
  return `${address?.substring(0, 10)}...${address?.substring(address?.length - 10, address?.length)}`;
};
